import { FormGroup, Input, Label } from "reactstrap";
import DefaultModal from "./Default";
import DefaultButton from "../Buttons/Default";
import { useState } from "react";
import { API_URL } from "../../utils/constants";
import { toast, ToastContainer } from "react-toastify";
import { BsBuildings } from "react-icons/bs";
import { PRIMARY } from "../../utils/colors";
import { useTranslation } from "react-i18next";

function OfficeSettingsModal({isOpen, toggle, user}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    name: user?.office?.name || '',
    phoneNumber: user?.office?.phone_number || '',
    whatsappNumber: user?.office?.whatsapp_number || '',
    email: user?.office?.email || '',
    address: user?.office?.address || ''
  });

  const update = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL+'/user/office/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        name: state.name,
        phone_number: state.phoneNumber,
        whatsapp_number: state.whatsappNumber,
        email: state.email,
        address: state.address
      }),
    });
    const data = await response.json();    
    if (data.success) {
      toast.success('تم تحديث بيانات المكتب بنجاح');
      localStorage.setItem('user', JSON.stringify(data.user));
      toggle();
    } else {
      console.log("Error:", data);
    }
    setIsLoading(false);
  };

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      title={ t('profile.office') }
      size="md"
    >
      <ToastContainer 
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        autoClose={2000}
      />

      <div className="text-center py-4">
        <BsBuildings size={50} color={PRIMARY} />
      </div>

      <FormGroup>
        <Label>{ t('profile.office_name') }: </Label>
        <Input 
          type="text" 
          value={state.name} 
          onChange={(e) => setState({...state, name: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.phone_number') }: </Label>
        <Input 
          type="text" 
          value={state.phoneNumber} 
          onChange={(e) => setState({...state, phoneNumber: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.whatsapp_number') }: </Label>
        <Input 
          type="text" 
          value={state.whatsappNumber} 
          onChange={(e) => setState({...state, whatsappNumber: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.email') }: </Label>
        <Input 
          type="text" 
          value={state.email} 
          onChange={(e) => setState({...state, email: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.address') }: </Label>
        <Input 
          type="textarea" 
          value={state.address}
          onChange={(e) => setState({...state, address: e.target.value})}
        />
      </FormGroup>
      <div className="text-center">
        <DefaultButton
          loading={isLoading}
          onClick={update}
          disabled={isLoading || !state.name || !state.phoneNumber || state.phoneNumber.length < 9}
        >
          { t('profile.save') }
        </DefaultButton>
      </div>
    </DefaultModal>
  );
}

export default OfficeSettingsModal;